import type { Category } from "@/lib/categories";

const STYLES: Record<Category, string> = {
  DeFi: "badge-blue",
  TradFi: "badge-gray",
  Regulatory: "badge-red",
  Uncategorized: "badge-yellow",
};

export default function CategoryTag({ category }: { category: Category }) {
  return <span className={`badge ${STYLES[category]}`}>{category}</span>;
}
